<template>
  <div class="container application">
    <div class="term-desc" />
    <validation-observer ref="validator" v-slot="{ errors }">
      <h2>계약자 주소</h2>
      <div class="content">
        <small>
          계약서에 반영될 실 거주지 주소를 기재해 주세요.<br>
          {{ userName }} 님의 이용 고지서가 해당 주소지로 발송될 예정입니다.
        </small>
      </div>

      <div class="input-item">
        <div class="input-label">주소 검색<span class="red050">*</span></div>
        <div class="row-member-license">
          <div class="col-left" :class="{ error: hasError(errors, '우편번호')}">
            <validator :rules="['required', 'numeric']" name="우편번호">
              <input
                id="postcode"
                v-model="postcode"
                name="postcode"
                class="form-field"
                type="text"
                placeholder="우편번호"
                :disabled="true"
              >
            </validator>
          </div>
          <div class="col-right" :class="{ error: true }">
            <button
              type="submit"
              class="btn btn_lg btn_sm"
              @click.prevent="openAddressPopup(displayAddress || postcode, 'use')"
            >
              주소검색
            </button>
          </div>
        </div>
        <div :class="{ error: hasError(errors, '주소')}">
          <label for="displayAddress" class="form-label screen-reader-text">주소</label>
          <validator rules="required" name="주소">
            <input
              id="displayAddress"
              v-model="displayAddress"
              name="displayAddress"
              type="text"
              placeholder="주소"
              class="form-field"
              :disabled="true"
            >
          </validator>
        </div>
        <div class="input-label">상세 주소<span class="red050">*</span></div>
        <div :class="{ error: hasError(errors, '상세 주소')}">
          <label for="detailAddress" class="form-label screen-reader-text">상세 주소</label>
          <validator rules="" name="상세 주소">
            <input
              id="detailAddress"
              v-model="detailAddress"
              name="detailAddress"
              type="text"
              placeholder="상세 주소"
              class="form-field"
            >
          </validator>
        </div>
      </div>

      <div class="term-desc" />
      <h2>차량 인수 정보</h2>
      <div class="content">
        <small>
          차량 인수를 위한 정보를 입력해 주세요.<br>
          대여 지역에 따라 인수 방법이 달라질 수 있습니다.
        </small>
      </div>

      <div class="input-item">
        <div class="input-label">인수 방법<span class="red050">*</span></div>
        <div :class="{ error: hasError(errors, '인수 방법')}">
          <validator rules="required" name="인수 방법">
            <horizontal-radio
              v-model="carConsignmentMethod"
              name="carConsignmentMethod"
              :items="carConsignmentMethods"
              :readonly="isFixedMethod()"
              value-key="name"
            />
          </validator>
        </div>
      </div>

      <div class="mt-1 blue050">
        <small v-if="isConsignment">
          * 현재 제주 외 지역은 배송만 가능합니다.<br>
          * 배송을 통한 인수, 반납 시 배송료가 발생하며, 인수 지역별 배송료는 결제 정보에서 확인 가능합니다.<br>
          * 배송의 경우 비대면으로 이루어지며 차량 도착 시 도착 알림을 드립니다.
        </small>
        <small v-if="!isConsignment">
          * 현재 제주 지역은 자체 픽업 인수만 가능합니다,<br>
          * 지정한 인수 시간 외 픽업은 불가하며, 픽업 장소는 아래 주소를 참고해주세요.<br>
          주소 : 제주특별자치도 제주시 일주서로 7907 쏘카 스테이션 제주
        </small>
      </div>

      <div v-if="isConsignment" class="input-item">
        <div class="input-label">
          인수 장소
          <span class="red050">*</span>
          <a class="ml-1 detail" href="#" style="text-decoration:underline" @click.prevent="openPage('https://socar-plan.zendesk.com/hc/ko/articles/4403527720089')">가능 지역 보기</a>
        </div>
        <div :class="{ error: hasError(errors, '인수 장소')}">
          <validator rules="required" name="인수 장소">
            <horizontal-radio
              v-model="carConsignmentArea"
              name="carConsignmentArea"
              :items="carConsignmentAreaItems"
              value-key="name"
            />
          </validator>
          <div class="mt-1 blue050">
            <small>
              해당 차량의 인수 가능 지역은 {{ application.regionName }} 입니다.<br>
              지역 별 인수가 가능한 장소는 '가능 지역 보기'를 눌러 확인해 주세요.
            </small>
          </div>
        </div>
      </div>

      <div v-if="isConsignment" class="input-item">
        <div class="input-label">인수지 주소<span class="red050">*</span></div>
        <div class="row-member-license">
          <div class="col-left" :class="{ error: hasError(errors, '우편번호')}">
            <validator :rules="['required', 'numeric']" name="우편번호">
              <input
                id="consignmentPostcode"
                v-model="consignmentPostcode"
                name="consignmentPostcode"
                class="form-field"
                type="text"
                placeholder="우편번호"
                :disabled="true"
              >
            </validator>
          </div>
          <div v-if="isConsignment && isAnotherPlace" class="col-right" :class="{ error: true }">
            <button
              type="submit"
              class="btn btn_lg btn_sm"
              @click.prevent="openAddressPopup(consignmentAddress || consignmentPostcode, 'consignment')"
            >
              주소검색
            </button>
          </div>
        </div>
        <div :class="{ error: hasError(errors, '주소')}">
          <label for="consignmentAddress" class="form-label screen-reader-text">주소</label>
          <validator rules="required" name="주소">
            <input
              id="consignmentAddress"
              v-model="consignmentAddress"
              name="consignmentAddress"
              type="text"
              placeholder="주소"
              class="form-field"
              :disabled="true"
            >
          </validator>
        </div>
      </div>

      <div v-if="isConsignment" class="input-item">
        <div class="input-label">인수 장소 유형<span class="red050">*</span></div>
        <div :class="{ error: hasError(errors, '인수 장소 유형')}">
          <validator rules="required" name="인수 장소 유형">
            <select-box
              id="takeOverLocationType"
              :option="takeOverLocationTypes"
              :default-value="application.takeOverLocationTypeId"
              @change="takeOverLocationTypeChange"
            />
          </validator>
        </div>
        <small v-if="takeOverLocationTypeMessage != null" class="blue050">
          {{ takeOverLocationTypeMessage }}<br>
        </small>
      </div>

      <div v-if="isConsignment">
        <div class="input-label">주차장 상세 설명<span class="red050">*</span></div>
        <div :class="{ error: hasError(errors, '인수 시 주차 장소')}">
          <label for="consignmentDetailAddress" class="form-label screen-reader-text">인수 시 주차 장소<span class="red050">*</span></label>
          <validator rules="" name="인수 시 주차 장소">
            <input
              id="consignmentDetailAddress"
              v-model="consignmentDetailAddress"
              name="consignmentDetailAddress"
              type="text"
              placeholder="인수 시 주차 장소"
              class="form-field"
            >
          </validator>
        </div>
      </div>

      <div class="input-item">
        <div class="input-label">인수 시간<span class="red050">*</span></div>
        <vs-row :class="{ error: hasError(errors, '인수 시간')}">
          <vs-col vs-w="12" vs-xs="12" vs-sm="6" vs-lg="6" class="take-over-date">
            <input
              name="rentRequestDate"
              class="form-field"
              type="text"
              :value="rentRequestDate"
              :disabled="true"
            >
          </vs-col>
          <vs-col vs-w="12" vs-xs="12" vs-sm="6" vs-lg="6" class="take-over-time">
            <validator rules="required" name="인수 시간">
              <select-box
                id="takeOverTime"
                :option="availableTimes"
                :default-value="application.takeOverTime"
                @change="takeOverTimeChange"
              />
            </validator>
          </vs-col>
        </vs-row>
      </div>

      <div class="mt-1 blue050">
        <small>
          인수 시간을 반드시 지켜주세요! 인수 시간으로부터 10분 이상 지연되거나 연락되지 않았을 경우 인수에 불편을 겪으실 수 있습니다.<br>
          도로 상황에 따라 인수시간보다 일찍 도착할 수 있습니다. 차량 도착 시 알림을 드리니 차량을 확인해주세요.
        </small>
      </div>

      <div class="input-item">
        <div class="input-label">특이사항</div>
        <div :class="{ error: hasError(errors, '특이사항')}">
          <textarea
            v-model="takeOverLocationDetail"
            placeholder="인수 장소 입/주차 시 필요한 정보를 기재해 주세요."
            class="form-textarea"
          />
        </div>
      </div>
      <div class="mt-1 blue050">
        <small>
          * 주정차 단속, 견인 위험 장소, 상점 영업을 방해하는 장소에는 주차할 수 없습니다.<br>
          * 유료 주차장으로 인수 장소를 지정한 경우 발생하는 주차비는 계약자 부담입니다.<br>
          * 도로 상황에 따라 차량 도착 시간이 달라질 수 있습니다.
        </small>
      </div>

      <div class="input-item">
        <div class="input-label">추천인</div>
        <div class="flex-container">
          <div class="col-left input-margin">
            <input
              id="referrerEmail"
              v-model="referrerEmail"
              name="referrerEmail"
              type="text"
              placeholder="추천인의 쏘카ID를 입력해주세요."
              class="form-field"
              :disabled="(disabledVerifyReferrer && referrerEmail !== null)"
            >
          </div>
          <div class="col-right" :class="{ error: true }">
            <button
              type="submit"
              class="btn btn_lg btn_sm"
              :disabled="disabledVerifyReferrer"
              @click.prevent="verifyReferrer"
            >
              확인
            </button>
          </div>
        </div>

        <div class="input-item">
          <div class="input-label">쿠폰 코드</div>
          <div class="col-left">
            <input
              id="couponCode"
              v-model="couponCode"
              name="couponCode"
              type="text"
              placeholder="쿠폰 코드를 입력해주세요."
              class="form-field"
            >
          </div>
        </div>

        <h2 class="marketing-heading">마케팅 활용 정보</h2>
        <div class="input-item">
          <div class="input-label">유입 경로</div>
          <div :class="{ error: hasError(errors, '유입 경로')}">
            <select-box
              id="funnel"
              :option="funnels"
              :default-value="application.funnel"
              @change="funnelChange"
            />
          </div>
          <div v-if="showFunnelInput">
            <input
              id="funnelEtc"
              v-model="funnelEtc"
              name="funnelEtc"
              class="form-field"
              type="text"
              placeholder="유입경로(기타) 입력"
            >
          </div>
        </div>

        <div class="input-item">
          <div class="input-label">사용 목적</div>
          <div :class="{ error: hasError(errors, '사용 목적')}">
            <select-box
              id="purpose"
              :option="purposes"
              :default-value="application.purpose"
              @change="purposeChange"
            />
          </div>
          <div v-if="showPurposeInput">
            <input
              id="purposeEtc"
              v-model="purposeEtc"
              name="purposeEtc"
              class="form-field"
              type="text"
              placeholder="사용목적(기타) 입력"
            >
          </div>
        </div>
      </div>
    </validation-observer>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="back"
        >
          이전
        </button>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full"
          :disabled="!valid"
          @click.prevent="next"
        >
          다음
        </button>
      </vs-col>
    </vs-row>
    <!-- popup -->
    <vs-popup title="주소 찾기" :active.sync="showAddressPopup">
      <address-search :q="addressQuery" :type="addressType" @complete="onAddressSearch($event)" />
    </vs-popup>
  </div>
</template>

<script>
import { find, get, reduce, round, last, cloneDeep, indexOf } from 'lodash';
import AddressSearch from 'components/AddressSearch';
import HorizontalRadio from 'components/HorizontalRadio';
import config from 'config';
import loadScriptOnce from 'load-script-once';
import AddressUtil from 'utils/address';
import DialogUtil from 'utils/dialog';
import SelectBox from 'components/SelectBox';
import HeaderUtil from 'utils/header';
import OpenAppUtil from 'utils/openApp';
import * as amplitude from '@amplitude/analytics-browser';
import ApiClient, { API } from 'api/client';

const shrinkCoords = ({ lat, lng }) => ({ lat: round(lat, locationPrecision), lng: round(lng, locationPrecision) });
const locationPrecision = 6;

export default {
  name: 'Basic',
  components: {
    AddressSearch,
    HorizontalRadio,
    SelectBox,
  },
  mixins: [ApiClient],
  props: {
    carConsignmentMethods: {
      type: Array,
      default: () => ([]),
    },
    takeOverLocationTypes: {
      type: Array,
      default: () => ([]),
    },
    availableTimes: {
      type: Array,
      default: () => ([]),
    },
    funnels: {
      type: Array,
      default: () => ([]),
    },
    purposes: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    availableRegions: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      appKey: config.daumMap.appKey,
      carConsignmentAreaItems: [{ label: '계약자 주소와 동일', name: 'SAME' }, { label: '다른 주소 입력', name: 'NEW' }],
      showAddressPopup: false,
      addressQuery: '',
      application: cloneDeep(this.data),
      addressType: '', // 주소 검색 타입
      takeOverLocationTypeMessage: null,
      disabledVerifyReferrer: true,
    };
  },
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    valid() {
      if (this.disabledVerifyReferrer === false) {
        return false;
      }
      const keyList = ['postcode', 'displayAddress', 'detailAddress', 'takeOverTime'];
      if (this.isConsignment) keyList.push('takeOverLocationType', 'consignmentPostcode', 'consignmentAddress', 'consignmentDetailAddress');
      return reduce(this.application, (result, val, key) => {
        if (indexOf(keyList, key) > -1) {
          return (result && val != null && val !== '');
        } else return result && true;
      }, true);
    },
    rentRequestDate() {
      return get(this.application, 'rentRequestDate');
    },
    isAnotherPlace() {
      return this.carConsignmentArea === 'NEW';
    },
    isConsignment() {
      if (this.carConsignmentMethod !== 'CSNHD_HANDLE_RESERVATION') {
        this.takeOverLocationTypeChange();
      }
      return this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION';
    },
    postcode: {
      get() {
        return this.application.postcode;
      },
      set(val) {
        this.application.postcode = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.consignmentPostcode = val;
        }
      },
    },
    displayAddress: {
      get() {
        return this.application.displayAddress;
      },
      set(val) {
        this.application.displayAddress = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.consignmentAddress = val;
        }
      },
    },
    detailAddress: {
      get() {
        return this.application.detailAddress;
      },
      set(val) {
        this.application.detailAddress = val;
      },
    },
    region1: {
      get() {
        return this.application.region1;
      },
      set(val) {
        this.application.region1 = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.application.consignmentRegion1 = val;
        }
      },
    },
    region2: {
      get() {
        return this.application.region2;
      },
      set(val) {
        this.application.region2 = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.application.consignmentRegion2 = val;
        }
      },
    },
    region3: {
      get() {
        return this.application.region3;
      },
      set(val) {
        this.application.region3 = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.application.consignmentRegion3 = val;
        }
      },
    },
    location: {
      get() {
        return this.application.location;
      },
      set(val) {
        this.application.location = val;
        if (this.carConsignmentArea === 'SAME' && this.carConsignmentMethod === 'CSNHD_HANDLE_RESERVATION') {
          this.application.consignmentLocation = val;
        }
      },
    },
    consignmentPostcode: {
      get() {
        return this.application.consignmentPostcode;
      },
      set(val) {
        this.application.consignmentPostcode = val;
      },
    },
    consignmentAddress: {
      get() {
        return this.application.consignmentAddress;
      },
      set(val) {
        this.application.consignmentAddress = val;
      },
    },
    consignmentDetailAddress: {
      get() {
        return this.application.consignmentDetailAddress;
      },
      set(val) {
        this.application.consignmentDetailAddress = val;
      },
    },
    carConsignmentArea: {
      get() {
        return this.application.carConsignmentArea;
      },
      set(val) {
        this.application.carConsignmentArea = val;
        if (val === 'SAME') {
          this.consignmentPostcode = this.postcode;
          this.consignmentAddress = this.displayAddress;
          this.application.consignmentRegion1 = this.region1;
          this.application.consignmentRegion2 = this.region2;
          this.application.consignmentRegion3 = this.region3;
          this.application.consignmentLocation = this.location;
        } else {
          this.consignmentPostcode = null;
          this.consignmentAddress = null;
          this.consignmentDetailAddress = null;
          this.application.consignmentRegion1 = null;
          this.application.consignmentRegion2 = null;
          this.application.consignmentRegion3 = null;
          this.application.consignmentLocation = null;
        }
      },
    },
    carConsignmentMethod: {
      get() {
        return this.application.method || '';
      },
      set(val) {
        this.application.method = val;
        if (val === 'CSNHD_SELF_PICKUP') {
          this.consignmentPostcode = null;
          this.consignmentAddress = null;
          this.consignmentDetailAddress = null;
          this.application.consignmentRegion1 = null;
          this.application.consignmentRegion2 = null;
          this.application.consignmentRegion3 = null;
          this.application.consignmentLocation = null;
        } else if (this.carConsignmentArea === 'SAME') {
          this.consignmentPostcode = this.postcode;
          this.consignmentAddress = this.displayAddress;
          this.application.consignmentRegion1 = this.region1;
          this.application.consignmentRegion2 = this.region2;
          this.application.consignmentRegion3 = this.region3;
          this.application.consignmentLocation = this.location;
        }
      },
    },
    takeOverLocationDetail: {
      get() {
        return this.application.takeOverLocationDetail || '';
      },
      set(val) {
        this.application.takeOverLocationDetail = val;
      },
    },
    funnelEtc: {
      get() {
        return this.application.funnelEtc;
      },
      set(val) {
        this.application.funnelEtc = val;
      },
    },
    purposeEtc: {
      get() {
        return this.application.purposeEtc;
      },
      set(val) {
        this.application.purposeEtc = val;
      },
    },
    referrerEmail: {
      get() {
        return this.application.referrerEmail;
      },
      set(val) {
        this.application.referrerEmail = val === '' ? null : val;
        this.disabledVerifyReferrer = this.application.referrerEmail === null;
      },
    },
    couponCode: {
      get() {
        return this.application.couponCode;
      },
      set(val) {
        this.application.couponCode = val;
      },
    },
    showFunnelInput() {
      const etcItem = last(this.funnels);
      return etcItem !== undefined && this.application.funnel === etcItem.id;
    },
    showPurposeInput() {
      const etcItem = last(this.purposes);
      return find(this.application.purpose, (item) => (etcItem.id === item));
    },
  },
  created() {
    const { regionGroup, carType, carTypeId, prepaidRate } = this.data;
    const args = {
      page_name: 'plan_contract_3_check_delivery',
      event_label: regionGroup.id || '',
      event_category: document.title,
      page_url: document.URL,
      component_state: prepaidRate === 0 ? '' : `prepayments_${prepaidRate * 100}%`,
      component_type: carType.thumbnailTags.map(({ id }) => id).join(','),
      component_category: carType.carClassTag.id || '',
      component_id: carTypeId,
      service_type: carType.benefitTags.map(({ id }) => id).join(','),
    };
    this.$gtag.event('view', args);
    amplitude.logEvent('view', args);
  },
  mounted() {
    loadScriptOnce(`//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${this.appKey}&libraries=services`)
      .then(() => {
        this.kakaoMap = window.kakao.maps;
        this.kakaoMap.load();
      })
      .catch(err => {
        // eslint-disable-next-line
        console.error(err);
      });
  },
  methods: {
    openPage(url) {
      if (HeaderUtil.isAndroid()) {
        OpenAppUtil.openExternal(url);
      } else {
        window.open(url, '_blank');
      }
    },
    isFixedMethod() {
      if (!this.data.regionGroup.pickup) this.carConsignmentMethod = 'CSNHD_HANDLE_RESERVATION';
      if (!this.data.regionGroup.consignment) this.carConsignmentMethod = 'CSNHD_SELF_PICKUP';
      if (this.application.regionGroup.pickup && this.application.regionGroup.consignment) return false;
      return true;
    },
    takeOverTimeChange(val) {
      this.application.takeOverTime = get(val, 'id', null);
      this.application.consignAt = (val && `${this.application.rentRequestDate} ${get(val, 'label')}`) || null;
    },
    takeOverLocationTypeChange(val) {
      this.application.takeOverLocationTypeId = get(val, 'id', null);
      this.application.takeOverLocationType = get(val, 'name', null);
      this.takeOverLocationTypeMessage = get(val, 'message', null);
    },
    funnelChange(val) {
      this.application.funnel = get(val, 'id', null);
    },
    purposeChange(val) {
      this.application.purpose = get(val, 'id', null);
    },
    next() {
      const { contractId } = this.data;
      const args = {
        page_name: 'plan_car_contract',
        event_category: document.title,
        page_url: document.URL,
        component_name: 'plan_check_delivery_next_button',
        reservation_id: contractId,
      };
      this.$gtag.event('click', args);
      amplitude.logEvent('click', args);

      if (this.application.method === 'CSNHD_HANDLE_RESERVATION') {
        const checkRegion = find(this.availableRegions, (item) => (item.region1 === this.application.consignmentRegion1 && item.region2 === this.application.consignmentRegion2));
        if (checkRegion === undefined) {
          DialogUtil.alert(`해당 계약은 ${this.application.regionName} 일부 지역에서만 인수 가능합니다.\n입력하신 인수 지역은 아쉽게도 현재 서비스 지역이 아닙니다.\n인수 가능 위치를 다시 확인해주세요.`);
          return;
        }
      }
      this.$emit('next', this.application);
    },
    back() {
      this.$emit('back');
    },
    openAddressPopup(query, type) {
      this.addressType = type;
      this.addressQuery = query;
      this.showAddressPopup = true;
    },
    async onAddressSearch(result) {
      this.addressQuery = '';
      this.showAddressPopup = false;
      await this.setAddress(result);
      this.addressType = '';
    },
    async setAddress(result) {
      const postcode = result.zonecode;
      const bname = result.bname;
      const buildingName = result.buildingName;

      let address = result.jibunAddress || result.autoJibunAddress;
      if (address && buildingName) {
        address += ` ${buildingName}`;
      }

      let streetAddress = result.roadAddress || result.autoRoadAddress;
      if (streetAddress && buildingName) {
        const extraAddress = (buildingName && `(${bname}, ${buildingName})`) || '';
        streetAddress += ` ${extraAddress}`;
      }
      const displayAddress = streetAddress || address;
      const keyword = (result.userSelectedType === 'J') ? result.jibunAddress : result.roadAddress;
      const location = shrinkCoords(await this.setLocation(keyword));
      const { region1, region2, region3 } = AddressUtil.getRegions(result);
      if (result.type === 'use') {
        this.displayAddress = displayAddress;
        this.postcode = postcode;
        this.application.address = address;
        this.application.streetAddress = streetAddress;
        this.region1 = region1;
        this.region2 = region2;
        this.region3 = region3;
        this.location = location;
      } else {
        this.consignmentAddress = displayAddress;
        this.consignmentPostcode = postcode;
        this.application.consignmentRegion1 = region1;
        this.application.consignmentRegion2 = region2;
        this.application.consignmentRegion3 = region3;
        this.application.consignmentLocation = location;
      }
    },
    setLocation(address) {
      return new Promise((resolve, reject) => {
        const geoCoder = new this.kakaoMap.services.Geocoder();
        geoCoder.addressSearch(address, (result, status) => {
          if (status === this.kakaoMap.services.Status.OK) {
            const location = {
              lat: result[0].y,
              lng: result[0].x,
            };
            resolve(location);
          } else {
            reject(new Error('address search fail.'));
          }
        });
      });
    },
    async verifyReferrer() {
      const storageItem = localStorage.getItem('socar-plan-application');
      const userEmail = JSON.parse(storageItem).user.email;
      if (!this.validReferrerEmail(userEmail)) {
        DialogUtil.alert('본인의 쏘카ID는 추천인으로 입력할 수 없습니다.');
        return;
      }

      const PromotionApi = this.getApi(API.PROMOTION);
      try {
        await PromotionApi.verifyReferrer({ referrerEmail: this.application.referrerEmail });
        DialogUtil.alert('입력이 완료되었습니다.');
        this.disabledVerifyReferrer = true;
      } catch (error) {
        DialogUtil.alert('잘못된 쏘카ID 입니다.');
      }
    },
    validReferrerEmail(userEmail) {
      return userEmail !== this.application.referrerEmail;
    },
  },
};
</script>

<style lang="scss" scoped>
.row-member-license.car-type {
  .col-left {
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .col-right {
    @media (max-width: 768px) {
      width: 100%;
    }
  }
}

.col-right .form-guide {
  margin-top: 20px;
  @media (max-width: 768px) {
    margin-top: 5px;
  }
}

.take-over-date {
  @media (max-width: 768px) {
    margin-bottom: 5px;
    margin-right: 0px;
  }
}
.take-over-time {
  padding-left: 5px;
  @media (max-width: 768px) {
    padding-left: 0px;
  }
}

.marketing-heading {
  margin-top: 50px;
}
.detail {
  font-weight: normal !important;
}

.flex-container {
  display: flex;
}

.input-margin {
  margin-right: 10px;
  width: 70%;
}
</style>
